// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimCategoryBreakdownDto
 */
export interface IClaimCategoryBreakdownDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimCategoryBreakdownDto
     */
    category_type?: IClaimCategoryBreakdownDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimCategoryBreakdownDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimCategoryBreakdownDto
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimCategoryBreakdownDto
     */
    claim_count?: number;
}

/**
* @export
* @enum {string}
*/
export enum IClaimCategoryBreakdownDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IClaimCategoryBreakdownDto interface.
 */
export function instanceOfIClaimCategoryBreakdownDto(value: object): value is IClaimCategoryBreakdownDto {
    return true;
}

export function IClaimCategoryBreakdownDtoFromJSON(json: any): IClaimCategoryBreakdownDto {
    return IClaimCategoryBreakdownDtoFromJSONTyped(json, false);
}

export function IClaimCategoryBreakdownDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimCategoryBreakdownDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'claim_count': json['claim_count'] == null ? undefined : json['claim_count'],
    };
}

export function IClaimCategoryBreakdownDtoToJSON(json: any): IClaimCategoryBreakdownDto {
    return IClaimCategoryBreakdownDtoToJSONTyped(json, false);
}

export function IClaimCategoryBreakdownDtoToJSONTyped(value?: IClaimCategoryBreakdownDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'amount': value['amount'],
        'percentage': value['percentage'],
        'claim_count': value['claim_count'],
    };
}

